<div class="investor-container" *ngIf="contractDetails">
    <!-- Main Content -->
    <div class="investor-main">
        <!-- Investor Profile Section -->
        <div class="investor-profile-section">
            <div class="profile-header">
                <div class="profile-avatar">
                    <img *ngIf="contractDetails?.user.image" 
                         [src]="contractDetails.user.image" 
                         alt="Investor Image" 
                         class="avatar-image"
                         (error)="onImageError($event)">
                    <div *ngIf="!contractDetails?.user.image" class="avatar-placeholder">
                        <i class="fas fa-user"></i>
                    </div>
                </div>
                <div class="profile-info">
                    <h1 class="investor-name">{{ contractDetails?.user.name || 'N/A' }}</h1>
                    <div class="investor-email">
                        <i class="fas fa-envelope"></i>
                        <span>{{ contractDetails?.user.email || 'N/A' }}</span>
                    </div>
                    <div class="investor-meta">
                        <div class="meta-item">
                            <i class="fas fa-phone"></i>
                            <span>{{ contractDetails?.user.phone_without_code || 'N/A' }}</span>
                        </div>
                        <!-- <div class="meta-item">
                            <i class="fas fa-map-marker-alt"></i>
                            <span>{{ contractDetails?.user.city || 'N/A' }}</span>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="profile-status">
                    <div class="status-badge" [class]="getStatusClass(contractDetails?.status)">
                        {{ contractDetails?.status || 'N/A' }}
                    </div>
                    <div class="contract-number">
                        <i class="fas fa-file-contract"></i>
                        <span>العقد: {{ contractDetails?.serial_number }}</span>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- Contact Information Section -->
        <div class="section-header">
            <div class="section-icon">
                <i class="fas fa-address-card"></i>
            </div>
            <h2 class="section-title mr-4">{{ 'MENU.DASHBOARD.contract_details_form' | translate }} {{ contractDetails?.serial_number}}</h2>
        </div>
        
        <div class="info-grid">
            <div class="info-card" *ngFor="let inst of installments">
                <div class="info-label">
                    <i class="fas fa-calendar-alt"></i>
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.payment_data' | translate }} : </span> {{inst.payment_date}} 
                </div>
                <div class="info-value">
                    <i class="fas fa-hand-holding-usd" style="color:#cca44c ;"></i> 
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.amount' | translate }} : </span> {{inst.amount}} {{ 'MENU.DASHBOARD.rs' | translate }} 
                </div>
                <div class="info-value">
                    <i class="fas fa-circle mt-1" style="color:#cca44c ;"></i>
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.status' | translate }} : </span> {{inst.status_text}} 
                </div>
                <div class="info-value" *ngIf="inst?.amount && inst?.amount_max">
  <i class="fas fa-percentage" style="color:#cca44c;"></i>
  <span style="font-weight: 500;" class="mx-1">
    {{ 'MENU.DASHBOARD.Ratio' | translate }} :
  </span>

  <div class="w-100 mt-1">
    <div class="progress" style="height: 8px;">
   <div
  class="progress-bar"
  role="progressbar"
  [class.bg-success]="getInstallmentRatio(inst) >= 75"
  [class.bg-warning]="getInstallmentRatio(inst) < 75 && getInstallmentRatio(inst) >= 40"
  [class.bg-danger]="getInstallmentRatio(inst) < 40"
  [style.width.%]="getInstallmentRatio(inst)"
></div>

    </div>
    <small class="text-muted">
      {{ getInstallmentRatio(inst) }}%
    </small>
  </div>
</div>

            </div>
        </div>
    </div>
</div>